module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/containers/layout/components/left-side/left-side.component.css
// module id = ./src/app/containers/layout/components/left-side/left-side.component.css
// module chunks = main